import service from '@/store/services/fms/payment_plan-service';

const state = {
  list: {},
  payment_plan: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, payment_plan) => {
    state.payment_plan = payment_plan;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((payment_plan) => { commit('SET_RESOURCE', payment_plan); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((payment_plan) => { commit('SET_RESOURCE', payment_plan); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((payment_plan) => { commit('SET_RESOURCE', payment_plan); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((payment_plan) => { commit('SET_RESOURCE', payment_plan); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  payment_plan: state => state.payment_plan,
};
 
const payment_plan = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default payment_plan;
